import styled from 'styled-components';
import colors from '_colors.module.scss';
import { BdsGrid, BdsIcon, BdsInput, BdsTypo } from 'blip-ds/dist/blip-ds-react';

export const SearchInput = styled(BdsInput)`
  width: 18.75rem;
`;

export const MoreOptionsButton = styled(BdsIcon)`
  cursor: pointer;
`;

export const EllipsisTypo = styled(BdsTypo)<{ ghost?: boolean }>`
  display: block;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  ${({ ghost }) => ghost && `color: ${colors.ContentGhost};`}

  &::part(bds-typo__text) {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const CellInnerGrid = styled(BdsGrid)`
  flex: 1;
  min-width: 0;
  overflow: hidden;
`;

export const CellRowGrid = styled(BdsGrid)`
  min-width: 0;
  overflow: hidden;
  width: 100%;
`;

export const ProcessingStatusTag = styled(BdsGrid)`
  bds-loading-spinner {
    height: 1rem;
    width: 1rem;
  }
`;
